var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29825 5.70175L18.2982 19.7018C18.4737 19.8947 18.7193 20 19 20C19.5439 20 20 19.5439 20 19C20 18.7193 19.8947 18.4737 19.7018 18.2982L5.70175 4.29824C5.52632 4.10526 5.2807 4 5 4C4.45614 4 4 4.45614 4 5C4 5.2807 4.10526 5.52632 4.29825 5.70175ZM18.2982 4.29824L4.29825 18.2982C4.10526 18.4737 4 18.7193 4 19C4 19.5439 4.45614 20 5 20C5.2807 20 5.52632 19.8947 5.70175 19.7018L19.7018 5.70175C19.8947 5.52632 20 5.2807 20 5C20 4.45614 19.5439 4 19 4C18.7193 4 18.4737 4.10526 18.2982 4.29824Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOutlined);
export default __webpack_public_path__ + "static/media/close_outlined.5a278286.svg";
export { ForwardRef as ReactComponent };